var map = {
	"./cert-finance-hkgcsmeaa-sc.jpg": 436,
	"./cert-fsi-hkgcsmeaa-sc.jpg": 438,
	"./cert-general-staff-a-hkgcsmeaa-sc.jpg": 440,
	"./cert-general-staff-hkgcsmeaa-sc.jpg": 442,
	"./cert-general2024-hkgcsmeaa-sc.jpg": 370,
	"./cert-senior-manager-hkgcsmeaa-sc.jpg": 448,
	"./cert-student-hkgcsmeaa-sc.jpg": 451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3271;